
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Tag, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Footer from '../components/Footer';

const OffersPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-white to-optout-gray">
      {/* Header */}
      <header className="py-6 px-4 bg-white shadow-sm">
        <div className="container mx-auto flex items-center">
          <Link to="/landing" className="text-optout-blue hover:text-optout-darkblue mr-4">
            <ArrowLeft className="h-5 w-5" />
          </Link>
          <h2 className="text-2xl font-bold text-optout-blue">Special Offers</h2>
        </div>
      </header>
      
      {/* Main Content */}
      <main className="flex-1 flex flex-col">
        <section className="py-16 md:py-24 px-4">
          <div className="container mx-auto max-w-4xl">
            <div className="text-center mb-12 animate-fade-in">
              <h1 className="text-4xl md:text-5xl font-bold text-optout-text mb-6 leading-tight">
                Exclusive Offers
              </h1>
              <p className="text-optout-lighttext text-lg max-w-2xl mx-auto">
                Check out these special promotions available just for you.
              </p>
            </div>
            
            {/* Placeholder for offers */}
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center mb-8 animate-fade-in">
              <div className="flex items-center justify-center mb-6">
                <AlertCircle className="h-12 w-12 text-optout-blue" />
              </div>
              <h2 className="text-2xl font-bold text-optout-text mb-4">Coming Soon</h2>
              <p className="text-optout-lighttext mb-6">
                We're preparing some amazing offers for you. Please check back soon!
              </p>
              <div className="flex justify-center">
                <Link to="/landing">
                  <Button className="bg-optout-blue hover:bg-optout-darkblue text-white">
                    Return to Home
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default OffersPage;
